<template>
  <li class="sb-menu--item">
    <notification :visible="notification" />
    <slot />
    {{ text }}
  </li>
</template>
<script>
import notification from "./Notification.vue";
export default {
  props: {
    text: String,
    notification: Boolean,
  },
  components: {
    notification,
  },
};
</script>
<style scoped>
#shopbox .sb-menu--item {
  margin: 0.65em 10px 0.65em;
  padding: 0.8em 0;
  cursor: pointer;
  transition: all 200ms ease-out;
  background: var(--shopbox-background-light);
  filter: brightness(96%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  position: relative;
}
#shopbox .sb-menu--item.sb-custom-button {
  padding: 0;
}
#shopbox .sb-menu--item.sb-custom-button a {
  text-align: center;
  padding: 0.8em 0;
  height: 100%;
  width: 100%;
}
#shopbox .sb-disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
#shopbox .sb-menu--item:not(.sb-disabled):hover {
  background: var(--shopbox-background-dark);
}
</style>
